// Échantillons de démonstration (modèle v2) : demos/{sampleId} = { projectId, name, createdBy, createdAt }.
// Lisibles en lecture seule par tous les comptes actifs, externes compris, même hors des projets partagés avec eux
// (firestore.rules) ; seuls les administrateurs en ajoutent ou en retirent.
import { collection, deleteDoc, doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import { docData } from './projects';

export function watchDemos(onChange, onError) {
  return onSnapshot(collection(db(), 'demos'), snap => {
    const demos = snap.docs.map(docData);
    demos.sort((a, b) => (a.name || '').localeCompare(b.name || '', 'fr'));
    onChange(demos);
  }, onError);
}

// Démo de cet échantillon : objet, null si l'échantillon n'en est pas une.
export function watchDemo(sampleId, onChange, onError) {
  return onSnapshot(doc(db(), 'demos', sampleId), snap => onChange(snap.exists() ? docData(snap) : null), onError);
}

// Fait (ou ne fait plus) de l'échantillon une démo ; name : nom affiché dans la liste des démos.
export const setDemo = (profile, projectId, sampleId, name) => (name
  ? setDoc(doc(db(), 'demos', sampleId), { projectId, name, createdBy: profile.uid, createdAt: serverTimestamp() })
  : deleteDoc(doc(db(), 'demos', sampleId)));

export const demoPath = demo => `/projects/${demo.projectId}/${demo.id}`;
